const logFactory = require('../../libraries/DigiTickets/Logging/logFactory');

/**
 * @constructor
 *
 * @param {PrinterAppPrintDriver} printerAppPrintDriver
 */
const AvailablePrintersManager = function (
    printerAppPrintDriver
) {
    this.printerAppPrintDriver = printerAppPrintDriver;

    this.log = logFactory('AvailablePrintersManager');
};

AvailablePrintersManager.prototype = {
    async getPrinterNames() {
        let printers;

        try {
            // Try loading printers from the print app.
            printers = await this.printerAppPrintDriver.getPrinterNames();
            this.log.log('Loaded printer names from Printer App', printers);
            return printers;
        } catch (e) {
            this.log.log('Failed to load printer names from app', e);
            throw new Error('Unable to load printer names. Please ensure the ProPoint Printer application or ProPoint Agent V3 is running.');
        }
    },
};

module.exports = AvailablePrintersManager;
